export const educationData = [
    {
        id: 1,
        institution: 'Sukkur IBA University',
        course: 'Bechlor in Software Engineering',
        startYear: '2018',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Govt. Boys Degree College Mithi',
        course: 'Intermediate',
        startYear: '2015',
        endYear: '2017'
    },
    {
        id: 3,
        institution: 'Sadiq Faqeer GBHS N/C Mithi',
        course: 'Matriculation',
        startYear: '2009',
        endYear: '2014'
    },
]